<template > 
    <div class="ordersContainer">

      <div class="loadingModal" v-if="isLoading">
            <div class="loader" ></div>
        </div>
        <div class="hero-section">
          <!-- <div class="sec-line">
            <h3>דף ההזמנות</h3>
          </div> -->
          <div class="line">
            <div class="search-box">
              <input type="text" v-model="txtSearch" placeholder="חיפוש הזמנה לפי שם, מספר טלפון או מספר הזמנה">
            </div>
            <div class="buttons-tools">
              <ul>
                <li>
                  <span @click="yesterdayOrders()" :class="[yesterdayItemNav == true ? 'activeItem' : '']">אתמול</span>
                  <span @click="todayOrders()" :class="[todayItemNav == true ? 'activeItem' : '']">היום</span>
                  <span @click="tommorowOrders()" :class="[tommorowItemNav == true ? 'activeItem' : '']">מחר</span>
                </li>
                <li>
                  <input type="date" v-model="fromDate" @change="loadOrdersRealTime()">
                  <span>עד</span>
                  <input type="date" v-model="toDate" @change="loadOrdersRealTime()">

                </li>
                <li @click="loadOrdersRealTime()"><button><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#363636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-refresh-cw-icon lucide-refresh-cw"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/></svg></button></li>
              </ul>
            </div>
          </div>
          
        </div>

 <div class="order-count">
            {{ filteredOrdersCount }} הזמנות שנמצאו לפי הסינון
          </div>
        <div class="orders-table">
          <orderCard   v-for="(order,index) in filteredOrders" :key="index" :id="order.ID" :order="order" :orderIndex="index"  v-if="order.Data.status !== 'נמחקה' "></orderCard>
        </div>
        <div class="no-orders" v-if="this.orders.length == 0">
           <div class="icon-false">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x-icon lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
              <span class="primary-text">אין הזמנות</span>
              <span class="secondary-text">
                לפי נתוני החיפוש לא נמצא כרגע הזמנות, נא לנסות מאוחר יותר.
              </span>
            </div>

        </div>

        <!-- المودال -->
        <div v-if="showModal" class="modal-overlay">
      <div class="modal-content">
        <button class="close-btn" @click="showModal = false">✖</button>
        <h3>📈 تقرير المبيعات</h3>

        <!-- حقل اختيار التاريخ -->
        <label>📅 اختر تاريخ:</label>
        <input type="date" v-model="selectedDate" @change="fetchSalesReport" class="datePicker">

        <button @click="fetchSalesReport" class="refresh-btn">🔄 تحديث التقرير</button>

        <div v-if="Object.keys(salesReport).length > 0" class="sales-list">
          <div v-for="(count, product) in salesReport" :key="product" class="sales-item">
            <span class="product-count">{{ count }} </span>
            <span class="product-name">{{ product }}</span>
          </div>
        </div>

        <p v-else>لا توجد مبيعات في هذا اليوم.</p>
      </div>
    </div>
    </div>
</template>
<script>
import { db } from '../firebase';
import firebase from "firebase/app";
import moment from 'moment';
import "firebase/storage"
import he from 'moment/locale/he'
import order from '../components/Order.vue';
import orderCard from '../components/orderCard.vue';
export default {
  name: 'OrdersBeta',
  components:{
    order,orderCard
  },
  data () {
    return {
      orders:[],
      txtSearch:'',
      toDate: '',
      fromDate: '',
      totalOrders:0,
      deletedOrders:0,
      acceptedOrders:0,
      fromToday:0,
      yesterdayItemNav:false,
      todayItemNav:false,
      tommorowItemNav:false,
      isLoading:true,
      salesReport: {}, // تخزين إجمالي المنتجات المباعة هنا 
      showModal: false, // يتحكم في عرض المودال
      selectedDate: new Date().toISOString().split("T")[0], // افتراضيًا اليوم الحالي\]
      unsubscribeOrders: null,



    }
  },
  watch: {
  selectedDate(newDate) {
    console.log("📅 تم تغيير التاريخ إلى:", newDate);
    this.fetchSalesReport();
  }
},

  created (){
    const m = moment();
    m.locale('he');
    console.log(m.format('LLLL'));
    let vm = this ;
    const today = moment().format("YYYY-MM-DD");
    vm.fromDate = today;
    vm.toDate = today;
    vm.todayItemNav = true;
    vm.loadOrdersRealTime();
    if(vm.totalOrders == 0){
      vm.totalOrders = 0 ;
    }

  },
  computed: {
    filteredOrders() {
      let vm = this;
      if (vm.txtSearch.length > 0) {
        let orders = [];
        for (let i = 0; i < vm.orders.length; i++) {
          let t = vm.orders[i];
          let found = false;

          if ((t.Data.fullname || '').toUpperCase().includes(vm.txtSearch.toUpperCase())) found = true;
          if ((t.Data.phoneNumber || '').toUpperCase().includes(vm.txtSearch.toUpperCase())) found = true;
          if ((t.Data.orderNumber || '').toString().includes(vm.txtSearch)) found = true;

          if (found) {
            orders.push(t);
          }
        }
        return orders;
      } else {
        return vm.orders;
      }
    },
    filteredOrdersCount() {
      return this.filteredOrders.filter(o => o.Data.status !== 'נמחקה').length;
    }
  },
    mounted() {
    this.fetchSalesReport(); // تحديث التقرير عند تحميل الصفحة بناءً على التاريخ الافتراضي
  },
  methods: {
    async fetchSalesReport() {
  console.log("🚀 جلب البيانات لتاريخ:", this.selectedDate);
  
  if (!this.selectedDate) return;

  const ordersRef = firebase.firestore().collection("orders");

  try {
    const snapshot = await ordersRef.where("dateOrder", "==", this.selectedDate).get();

    if (snapshot.empty) {
      console.warn("⚠️ لا توجد طلبات لهذا اليوم.");
      this.salesReport = {};
      return;
    }

    let salesData = {};

    snapshot.forEach(doc => {
      const order = doc.data();
      if (!order.cart || !Array.isArray(order.cart)) return;

      order.cart.forEach(product => {
        const productName = (product.Data && product.Data.Name) ? product.Data.Name : "منتج غير معروف";
        const quantity = product.selectedCount ? Number(product.selectedCount) : 0;

        if (!salesData[productName]) {
          salesData[productName] = 0;
        }
        salesData[productName] += quantity;
      });
    });

    this.salesReport = salesData;
    console.log("✅ البيانات المحدثة:", this.salesReport);

  } catch (error) {
    console.error("❌ حدث خطأ أثناء جلب البيانات:", error);
  }
}
,

      todayOrders(){
        let vm = this;
        vm.todayItemNav = true;
        vm.tommorowItemNav = false;
        vm.yesterdayItemNav = false;

        vm.totalOrders = 0 ;
        vm.deletedOrders = 0;
        vm.acceptedOrders = 0;
        vm.fromDate = moment().format("YYYY-MM-DD");
        vm.toDate = moment().format("YYYY-MM-DD");
        
        vm.loadOrdersRealTime()
      },
      tommorowOrders(){
        let vm = this;
        vm.tommorowItemNav = true;
        vm.todayItemNav = false;
        vm.yesterdayItemNav = false;
        vm.totalOrders = 0 ;
        vm.deletedOrders = 0;
        vm.acceptedOrders = 0;
        vm.fromDate = moment().add(1, 'days').format("YYYY-MM-DD");
        vm.toDate = moment().add(1, 'days').format("YYYY-MM-DD");
        
        vm.loadOrdersRealTime()
      },
      thisMonth(){
        let vm = this;
        vm.tommorowItemNav = false;
        vm.todayItemNav = false;
        vm.yesterdayItemNav = false;
        vm.totalOrders = 0 ;
        vm.deletedOrders = 0;
        vm.acceptedOrders = 0;
        vm.fromDate = moment().startOf('month').format("YYYY-MM-DD");
        vm.toDate = moment().endOf('month').format("YYYY-MM-DD");
        
        vm.loadOrdersRealTime()
      },
      lastMonth(){
        let vm = this;
        vm.tommorowItemNav = false;
        vm.todayItemNav = false;
        vm.yesterdayItemNav = false;
        vm.totalOrders = 0 ;
        vm.deletedOrders = 0;
        vm.acceptedOrders = 0;
        vm.fromDate = moment().subtract("1","months").startOf('month').format("YYYY-MM-DD");
        vm.toDate = moment().subtract("1","months").endOf('month').format("YYYY-MM-DD");
        
        vm.loadOrdersRealTime()
      },
      yesterdayOrders(){
        let vm = this;
        vm.yesterdayItemNav = true;
        vm.todayItemNav = false;
        vm.tommorowItemNav = false;
        vm.totalOrders = 0 ;
        vm.deletedOrders = 0;
        vm.acceptedOrders = 0;
        vm.fromDate = moment().subtract(1, 'days').format("YYYY-MM-DD");
        vm.toDate = moment().subtract(1, 'days').format("YYYY-MM-DD");
        
        vm.loadOrdersRealTime()
      },
      loadOrders(){
          let vm = this;
          vm.orders = [];
          vm.totalOrders = 0 ;
          vm.deletedOrders = 0;
          vm.acceptedOrders = 0;
          vm.deletedOrders = 0;
          //  .orderBy("orderNumber","desc")
          // .where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate)
          db.collection("orders").where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate).orderBy("dateOrder","asc").get()
          .then(function(orderResult){
              for(let a = 0; a < orderResult.size; a++){
                  let orderId = orderResult.docs[a].id;
                  let order = orderResult.docs[a].data();
                  // console.log(orderResult.size);
                  vm.orders.push({ ID: orderId, Data: order });   
                  vm.totalOrders = orderResult.size;

                  if (order.status == 'נמחקה') {
                    vm.deletedOrders++;
                  }

              }

              if( vm.deletedOrders == 0){
                vm.acceptedOrders = vm.totalOrders;
              }
              // db.collection("orders").where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate).where('status', '==', 'נמחקה').get()
              // .then(function(deletedResult){
              //   for(let a = 0; a < deletedResult.size; a++){
              //     // console.log(vm.deletedOrders);
              //     // console.log(deletedResult.docs[a].id);
              //     vm.deletedOrders = deletedResult.size;
              //   } 
              //   if(vm.totalOrders - vm.deletedOrders <= 0){
              //     vm.acceptedOrders = vm.totalOrders;
              //   }
              //   if( vm.deletedOrders == 0){
              //       // vm.deletedOrders = 0;
              //       vm.acceptedOrders = vm.totalOrders;

              //     }
              //     else {
              //       vm.acceptedOrders = vm.totalOrders - vm.deletedOrders;
              //     }
              // }).catch(function(error){
              //     console.error("Error getting document:", error);
              //     });
          })

          .catch(function(error){
              console.error("Error getting document:", error);
      });
      },
      // loadOrdersRealTime(){
      //     let vm = this;
      //     vm.fromToday = 0;
      //     vm.totalOrders = 0 ;
      //     vm.deletedOrders = 0;
      //     vm.acceptedOrders = 0;
          
      //     //  .orderBy("orderNumber","desc")
      //     // .where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate)
      //     db.collection("orders").where('dateOrder', '>=', vm.fromDate)
      //     .where('dateOrder', '<=', vm.toDate).orderBy("dateOrder","asc").orderBy("timeOrder","asc").onSnapshot((orderResult) => {
      //       vm.isLoading = false;
      //       vm.orders = [];
      //       vm.totalOrders = orderResult.size;
      //         orderResult.forEach((doc) => {
      //                 let orderId = doc.id;
      //                 let order = doc.data();
      //                 // vm.totalOrders = doc.size;
      //                 vm.orders.push({ ID: orderId, Data: order });   
      //                 if(order.Date == order.dateOrder){
      //                 vm.fromToday++;
      //                 }
      //                 if(order.status == 'נמחקה'){
      //                   vm.deletedOrders++;
      //                 }
      //                 if( vm.deletedOrders == 0){
      //                   vm.acceptedOrders = vm.totalOrders;
      //                 }


      //               });
                    
      //         // db.collection("orders").where('dateOrder', '>=', vm.fromDate).where('dateOrder', '<=', vm.toDate).where('status', '==', 'נמחקה').get()
      //         // .then(function(deletedResult){
      //         //   for(let a = 0; a < deletedResult.size; a++){
      //         //     // console.log(vm.deletedOrders);
      //         //     // console.log(deletedResult.docs[a].id);
      //         //     vm.deletedOrders = deletedResult.size;
      //         // } 

      //         // if(vm.totalOrders - vm.deletedOrders <= 0){
      //         //   vm.acceptedOrders = vm.totalOrders;
      //         //     }
      //         //     if( vm.deletedOrders == 0){
      //         //       // vm.deletedOrders = 0;
      //         //       vm.acceptedOrders = vm.totalOrders;

      //         //     }
      //         //     else {
      //         //       vm.acceptedOrders = vm.totalOrders - vm.deletedOrders;
      //         //     }
      //         //     // console.log('deleted Orders :',vm.deletedOrders);
      //         //     // console.log('accepted Orders :',vm.acceptedOrders);

      //         //  })
      //         //  .catch(function(error){
      //         //     console.error("Error getting document:", error);
      //         //     });
                

      //           })
      //         },
  loadOrdersRealTime() {
  let vm = this;
  vm.fromToday = 0;
  vm.totalOrders = 0;
  vm.deletedOrders = 0;
  vm.acceptedOrders = 0;
  vm.orders = [];
  vm.isLoading = true;

  // إلغاء أي listener سابق إذا موجود
  if (vm.unsubscribeOrders) {
    vm.unsubscribeOrders();
  }

  const ordersRef = db.collection("orders");

  const query1 = ordersRef
    .where("dateOrder", ">=", vm.fromDate)
    .where("dateOrder", "<=", vm.toDate);

  const query2 = ordersRef
    .where("dayOrder", ">=", vm.fromDate)
    .where("dayOrder", "<=", vm.toDate);

  // شغّل المستمعين الفوريين
  const snapshotHandler = (snapshot1, snapshot2) => {
    let allDocs = [];

    snapshot1.forEach((doc) => {
      allDocs.push({ ID: doc.id, Data: doc.data() });
    });

    snapshot2.forEach((doc) => {
      if (!allDocs.find((o) => o.ID === doc.id)) {
        allDocs.push({ ID: doc.id, Data: doc.data() });
      }
    });

    vm.totalOrders = allDocs.length;

    allDocs.sort((a, b) => {
      const dateA = a.Data.selectedDateReadable || a.Data.dayOrder || a.Data.dateOrder || '';
      const dateB = b.Data.selectedDateReadable || b.Data.dayOrder || b.Data.dateOrder || '';

      const timeA = a.Data.timeOrder ? a.Data.timeOrder.padStart(5, '0') : '00:00';
      const timeB = b.Data.timeOrder ? b.Data.timeOrder.padStart(5, '0') : '00:00';

      const datetimeA = `${dateA} ${timeA}`;
      const datetimeB = `${dateB} ${timeB}`;

      return datetimeA.localeCompare(datetimeB);
    });

    vm.orders = allDocs;

    vm.fromToday = 0;
    vm.deletedOrders = 0;
    vm.acceptedOrders = 0;

    allDocs.forEach((order) => {
      const orderDate = order.Data.selectedDateReadable || order.Data.dayOrder || order.Data.dateOrder;
      if (orderDate === vm.fromDate) vm.fromToday++;

      if (order.Data.status === "נמחקה") vm.deletedOrders++;
    });

    vm.acceptedOrders = vm.totalOrders - vm.deletedOrders;
    vm.isLoading = false;
  };

  // اسمع للتحديثات من الاستعلامين
  const unsub1 = query1.onSnapshot(snapshot1 => {
    query2.onSnapshot(snapshot2 => {
      snapshotHandler(snapshot1, snapshot2);
    });
  });

  // خزّن unsubscribe عشان تستخدمه لما تتغير الفلاتر
  vm.unsubscribeOrders = () => unsub1();
}


      }
    }

</script>

<style scoped>
*{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: 'Noto Sans Hebrew';
}
.ordersContainer{
  width: 100%;
  padding: 1rem;
  background-color: #f9f9f9;
  min-height: 100vh;
}
.hero-section{
  width: 100%;
  background-color: transparent;
  display: flex;
  flex-direction: column;
}
.hero-section .line{
  width: 100%;
  background-color:transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.line .search-box{
  width: 50%;
}
.search-box input{
    background-color: #fff;
    border: 1px solid #d7d7d7;
    color: #363636;
    padding: 0px 10px;
    font-size: 14px;
    width: 320px;
    min-height: 40px;
    border-radius: 5px;
    outline: none;
}
.search-box input:focus{
  border-color: #363636;
}
.buttons-tools{
  width: 50%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.buttons-tools ul{
  list-style: none;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: end;
}
.buttons-tools ul li{
  display: inline-block;
  background-color: #fff;
  border: 1px solid #d7d7d7;
  color: #363636;
  padding: 0px 5px;
  font-size: 14px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  cursor: pointer;
}
.buttons-tools ul li:last-child{
  margin: 0;
  width: 40px;
  height: 40px;
}
.buttons-tools ul li:last-child button{
  background-color: transparent;
  border: 0;
  color: #363636;
}
.buttons-tools ul li:last-child button:hover {
  transform: rotate(90deg);
  transition: transform 0.3s ease;
}

.buttons-tools ul li:last-child:hover{
  background-color: rgba(255, 255, 255, 0.1);
  color: #014342;
}
.buttons-tools ul li input[type=date]{
    color: #363636;
    background: transparent;
    border: 0;
    text-align: center;
}
.activeItem{
  background-color: #363636;
  color: #fff;
  list-style: none;
  display: inline-block;
  padding: 0 10px;
  border-radius: 5px;
  line-height: 2;
}
.buttons-tools ul li span{
  border-radius: 5px;
  padding: 0 5px;
  margin: 0 5px;
}
.sec-line{
  width: 100%;
  padding: 1rem;  
}
.sec-line h3{
  color: #fff;
}
.order-count {
  font-size: 14px;
  color: #6c757d;
  margin: 1rem 0 ;
  display: block;
}
.orders-table{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}
.no-orders{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  flex-direction: column;
  height: 75vh;
}
.icon-false{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.icon-false svg{
  background: #e0e0e0;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  font-size: 2px;
}
.icon-false .primary-text{
  font-size: 20px;
  font-weight: 500;
  margin: 1rem 0;
}
.icon-false .secondary-text{
      font-size: 14px;
    color: #495057;
}
@media (max-width: 1350px){
  .orders-table{ grid-template-columns: repeat(3, minmax(0, 1fr)); }

}
@media (max-width: 992px){
  .orders-table{ grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 768px) {
  .hero-section .line {
    flex-direction: column;
    align-items: flex-start;
  }

  .line .search-box {
    width: 100%;
    margin-bottom: 10px;
  }

  .search-box input {
    width: 100%;
  }

  .buttons-tools {
    width: 100%;
    justify-content: space-between;
  }

  .buttons-tools ul {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .buttons-tools ul li {
    margin-bottom: 8px;
    font-size: 13px;
    padding: 5px;
  }

  .buttons-tools ul li input[type="date"] {
    font-size: 13px;
  }

  .buttons-tools ul li:last-child {
    width: auto;
    height: auto;
  }

  .sec-line {
    padding: 0.5rem 1rem;
  }

  .sec-line h3 {
    font-size: 16px;
  }

  .order-count {
    font-size: 13px;
    margin: 1rem 1rem 0.5rem 1rem;
  }

  .orders-table{ grid-template-columns: 1fr; }

}

</style>



// WEBPACK FOOTER //
// src/pages/ordersBeta.vue